/* Preserve the native cart POST fields; open checkout with an explicit English locale. */
(() => {
  const proceed = async (event) => {
    const button = event.type === 'click' ? event.target.closest('button[name="checkout"]') : event.submitter;
    const form = button?.form;
    if (event.defaultPrevented || !(form instanceof HTMLFormElement) || button?.name !== 'checkout') return;
    const action = new URL(form.action, location.href);
    if (action.origin !== location.origin || !/\/cart\/?$/.test(action.pathname)) return;
    event.preventDefault();
    event.stopPropagation();
    if (form.dataset.hkCheckoutPending === 'true') return;
    // Native theme click handlers enforce the cart's existing agreement checkbox.
    const agreement = form.querySelector('[data-agree-checkbox]');
    if (agreement && !agreement.checked) {
      agreement.focus();
      agreement.setCustomValidity(document.documentElement.lang.startsWith('ar') ? 'يرجى الموافقة على الشروط قبل المتابعة.' : 'Please agree to the terms before continuing.');
      agreement.reportValidity();
      agreement.addEventListener('change', () => agreement.setCustomValidity(''), { once: true });
      return;
    }
    form.dataset.hkCheckoutPending = 'true';
    const wasDisabled = button.disabled;
    button.disabled = true;
    const oldAlert = form.querySelector('[data-hk-checkout-error]');
    oldAlert?.remove();
    try {
      // Match the native theme's configured removal of temporary cart attributes.
      if (window.T4Sconfigs && !window.T4Sconfigs.CartAttrHidden) {
        form.querySelectorAll('[data-cart-attr-rm]').forEach((field) => { field.value = ''; });
      }
      const fields = new FormData(form);
      for (const key of ['checkout', 'goto_pp', 'goto_gc', 'return_to']) fields.delete(key);
      action.pathname = action.pathname.replace(/\/cart\/?$/, '/cart/update.js');
      action.search = '';
      const response = await fetch(action.href, {
        method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: fields,
      });
      if (!response.ok) throw new Error('Cart update failed');
      const cart = await response.json();
      if (!Number.isInteger(cart.item_count) || cart.item_count < 1) throw new Error('Cart is empty');
      const target = new URL('/checkout', location.origin);
      target.searchParams.set('locale', 'en');
      target.searchParams.set('skip_shop_pay', 'true');
      location.assign(target.href);
    } catch {
      form.dataset.hkCheckoutPending = 'false';
      button.disabled = wasDisabled;
      const message = document.createElement('p');
      message.dataset.hkCheckoutError = '';
      message.setAttribute('role', 'alert');
      message.textContent = document.documentElement.lang.startsWith('ar')
        ? 'تعذّر الانتقال إلى الدفع. يرجى المحاولة مرة أخرى.'
        : 'Unable to continue to checkout. Please try again.';
      button.after(message);
    }
  };
  document.addEventListener('click', proceed, true);
  document.addEventListener('submit', proceed, true);
})();
